import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/common.scss"
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import moment from 'moment'
// 挂载时间插件
Vue.prototype.$moment = moment
Vue.filter('dateFormat',function (input,fmtstring) {
  if(input){
    return moment(input).format(fmtstring);
  }else{
    return "";
  }
});

Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')